import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GeneralInfoIntroFormState {
  logo: string;
  header: string;
  description: string;
}

const initialState: GeneralInfoIntroFormState = {
  logo: '',
  header: '',
  description: '',
};
export const generalInfoIntroSlice = createSlice({
  name: 'generalInfoIntro',
  initialState,
  reducers: {
    setGeneralInfoIntroStateDefault: () => {
      return { ...initialState };
    },
    submitGeneralInfoIntro: (state, action: PayloadAction<GeneralInfoIntroFormState>) => {
      return action.payload;
    },
  },
});

export const { setGeneralInfoIntroStateDefault, submitGeneralInfoIntro } = generalInfoIntroSlice.actions;

export default generalInfoIntroSlice.reducer;
